module.exports = "fonts/GilroyMedium.woff2";